import React from "react";

interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({ className = "", style }) => (
  <div className={`bg-neutral-200 rounded animate-pulse ${className}`} style={style} />
);

export const LoadingSkeleton: React.FC = () => {
  return (
    <div className="space-y-6" data-testid="loading-skeleton">
      {/* Summary Cards Skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white rounded-lg border border-neutral-200 p-4 shadow-sm"
          >
            <Skeleton className="h-4 w-24 mb-2" />
            <Skeleton className="h-8 w-32" />
          </div>
        ))}
      </div>

      {/* Daily Chart Skeleton */}
      <div className="bg-white rounded-lg border border-neutral-200 p-6">
        <Skeleton className="h-6 w-40 mb-4" />
        <div className="flex items-end gap-1 h-48">
          {Array.from({ length: 30 }).map((_, i) => (
            <div key={i} className="flex-1">
              <Skeleton
                className="w-full"
                style={{ height: `${Math.random() * 80 + 20}%` }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Breakdown Charts Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="bg-white rounded-lg border border-neutral-200 p-4"
          >
            <Skeleton className="h-5 w-32 mb-4" />
            <div className="space-y-4">
              {[1, 2, 3].map((j) => (
                <div key={j}>
                  <div className="flex justify-between mb-1">
                    <Skeleton className="h-4 w-20" />
                    <Skeleton className="h-4 w-16" />
                  </div>
                  <Skeleton className="h-2 w-full rounded-full" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Top Rankings Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white rounded-lg border border-neutral-200 p-4"
          >
            <Skeleton className="h-5 w-28 mb-4" />
            <div className="space-y-3">
              {[1, 2, 3, 4, 5].map((j) => (
                <div key={j} className="flex items-center gap-3">
                  <Skeleton className="w-6 h-6 rounded-full" />
                  <div className="flex-1">
                    <Skeleton className="h-4 w-full mb-1" />
                    <Skeleton className="h-3 w-16" />
                  </div>
                  <Skeleton className="h-4 w-14" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingSkeleton;
